// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form = require("../common/Components/Form.bs.js");
let React = require("react");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Formality = require("@tan/formality/src/Formality.bs.js");
let Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Form__TextInput = require("../common/Components/Form__TextInput.bs.js");
let Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let SettingsPageHeader = require("./SettingsPageHeader.bs.js");
let Formality__ReactUpdate = require("@tan/formality/src/Formality__ReactUpdate.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let ProfilePageSocialMediaForm_agent_graphql = require("../../__generated__/ProfilePageSocialMediaForm_agent_graphql.bs.js");
let ProfilePageSocialMediaForm_UpdateAgentSocialMediaHandlesMutation_graphql = require("../../__generated__/ProfilePageSocialMediaForm_UpdateAgentSocialMediaHandlesMutation_graphql.bs.js");

let validators_facebookHandle = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => ({
    TAG: "Ok",
    _0: param.facebookHandle
  })
};

let validators_instagramHandle = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => ({
    TAG: "Ok",
    _0: param.instagramHandle
  })
};

let validators_linkedInHandle = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => ({
    TAG: "Ok",
    _0: param.linkedInHandle
  })
};

let validators_twitterHandle = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => ({
    TAG: "Ok",
    _0: param.twitterHandle
  })
};

let validators_yelpHandle = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => ({
    TAG: "Ok",
    _0: param.yelpHandle
  })
};

let validators_youTubeHandle = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => ({
    TAG: "Ok",
    _0: param.youTubeHandle
  })
};

let validators = {
  facebookHandle: validators_facebookHandle,
  instagramHandle: validators_instagramHandle,
  linkedInHandle: validators_linkedInHandle,
  twitterHandle: validators_twitterHandle,
  yelpHandle: validators_yelpHandle,
  youTubeHandle: validators_youTubeHandle
};

function initialFieldsStatuses(input) {
  return {
    facebookHandle: "Pristine",
    instagramHandle: "Pristine",
    linkedInHandle: "Pristine",
    twitterHandle: "Pristine",
    yelpHandle: "Pristine",
    youTubeHandle: "Pristine"
  };
}

let initialFieldStatuses_xxx = initialFieldsStatuses;

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: initialFieldsStatuses(input),
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses) {
  let match = fieldsStatuses.facebookHandle;
  let tmp;
  tmp = typeof match !== "object" ? validators.facebookHandle.validate(input) : match._0;
  let match$1 = fieldsStatuses.instagramHandle;
  let tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.instagramHandle.validate(input) : match$1._0;
  let match$2 = fieldsStatuses.linkedInHandle;
  let tmp$2;
  tmp$2 = typeof match$2 !== "object" ? validators.linkedInHandle.validate(input) : match$2._0;
  let match$3 = fieldsStatuses.twitterHandle;
  let tmp$3;
  tmp$3 = typeof match$3 !== "object" ? validators.twitterHandle.validate(input) : match$3._0;
  let match$4 = fieldsStatuses.yelpHandle;
  let tmp$4;
  tmp$4 = typeof match$4 !== "object" ? validators.yelpHandle.validate(input) : match$4._0;
  let match$5 = fieldsStatuses.youTubeHandle;
  let tmp$5;
  tmp$5 = typeof match$5 !== "object" ? validators.youTubeHandle.validate(input) : match$5._0;
  let facebookHandleResult = tmp;
  let facebookHandleResult$1;
  if (facebookHandleResult.TAG === "Ok") {
    let instagramHandleResult = tmp$1;
    if (instagramHandleResult.TAG === "Ok") {
      let linkedInHandleResult = tmp$2;
      if (linkedInHandleResult.TAG === "Ok") {
        let twitterHandleResult = tmp$3;
        if (twitterHandleResult.TAG === "Ok") {
          let yelpHandleResult = tmp$4;
          if (yelpHandleResult.TAG === "Ok") {
            let youTubeHandleResult = tmp$5;
            if (youTubeHandleResult.TAG === "Ok") {
              return {
                TAG: "Valid",
                output: {
                  facebookHandle: facebookHandleResult._0,
                  instagramHandle: instagramHandleResult._0,
                  linkedInHandle: linkedInHandleResult._0,
                  twitterHandle: twitterHandleResult._0,
                  yelpHandle: yelpHandleResult._0,
                  youTubeHandle: youTubeHandleResult._0
                },
                fieldsStatuses: {
                  facebookHandle: {
                    TAG: "Dirty",
                    _0: facebookHandleResult,
                    _1: "Shown"
                  },
                  instagramHandle: {
                    TAG: "Dirty",
                    _0: instagramHandleResult,
                    _1: "Shown"
                  },
                  linkedInHandle: {
                    TAG: "Dirty",
                    _0: linkedInHandleResult,
                    _1: "Shown"
                  },
                  twitterHandle: {
                    TAG: "Dirty",
                    _0: twitterHandleResult,
                    _1: "Shown"
                  },
                  yelpHandle: {
                    TAG: "Dirty",
                    _0: yelpHandleResult,
                    _1: "Shown"
                  },
                  youTubeHandle: {
                    TAG: "Dirty",
                    _0: youTubeHandleResult,
                    _1: "Shown"
                  }
                },
                collectionsStatuses: undefined
              };
            }
            facebookHandleResult$1 = facebookHandleResult;
          } else {
            facebookHandleResult$1 = facebookHandleResult;
          }
        } else {
          facebookHandleResult$1 = facebookHandleResult;
        }
      } else {
        facebookHandleResult$1 = facebookHandleResult;
      }
    } else {
      facebookHandleResult$1 = facebookHandleResult;
    }
  } else {
    facebookHandleResult$1 = facebookHandleResult;
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      facebookHandle: {
        TAG: "Dirty",
        _0: facebookHandleResult$1,
        _1: "Shown"
      },
      instagramHandle: {
        TAG: "Dirty",
        _0: tmp$1,
        _1: "Shown"
      },
      linkedInHandle: {
        TAG: "Dirty",
        _0: tmp$2,
        _1: "Shown"
      },
      twitterHandle: {
        TAG: "Dirty",
        _0: tmp$3,
        _1: "Shown"
      },
      yelpHandle: {
        TAG: "Dirty",
        _0: tmp$4,
        _1: "Shown"
      },
      youTubeHandle: {
        TAG: "Dirty",
        _0: tmp$5,
        _1: "Shown"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurFacebookHandleField" :
          let result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.facebookHandle, validators_facebookHandle, status => {
            let init = state.fieldsStatuses;
            return {
              facebookHandle: status,
              instagramHandle: init.instagramHandle,
              linkedInHandle: init.linkedInHandle,
              twitterHandle: init.twitterHandle,
              yelpHandle: init.yelpHandle,
              youTubeHandle: init.youTubeHandle
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurInstagramHandleField" :
          let result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.instagramHandle, validators_instagramHandle, status => {
            let init = state.fieldsStatuses;
            return {
              facebookHandle: init.facebookHandle,
              instagramHandle: status,
              linkedInHandle: init.linkedInHandle,
              twitterHandle: init.twitterHandle,
              yelpHandle: init.yelpHandle,
              youTubeHandle: init.youTubeHandle
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurLinkedInHandleField" :
          let result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.linkedInHandle, validators_linkedInHandle, status => {
            let init = state.fieldsStatuses;
            return {
              facebookHandle: init.facebookHandle,
              instagramHandle: init.instagramHandle,
              linkedInHandle: status,
              twitterHandle: init.twitterHandle,
              yelpHandle: init.yelpHandle,
              youTubeHandle: init.youTubeHandle
            };
          });
          if (result$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$2,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurTwitterHandleField" :
          let result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.twitterHandle, validators_twitterHandle, status => {
            let init = state.fieldsStatuses;
            return {
              facebookHandle: init.facebookHandle,
              instagramHandle: init.instagramHandle,
              linkedInHandle: init.linkedInHandle,
              twitterHandle: status,
              yelpHandle: init.yelpHandle,
              youTubeHandle: init.youTubeHandle
            };
          });
          if (result$3 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$3,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurYelpHandleField" :
          let result$4 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.yelpHandle, validators_yelpHandle, status => {
            let init = state.fieldsStatuses;
            return {
              facebookHandle: init.facebookHandle,
              instagramHandle: init.instagramHandle,
              linkedInHandle: init.linkedInHandle,
              twitterHandle: init.twitterHandle,
              yelpHandle: status,
              youTubeHandle: init.youTubeHandle
            };
          });
          if (result$4 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$4,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurYouTubeHandleField" :
          let result$5 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.youTubeHandle, validators_youTubeHandle, status => {
            let init = state.fieldsStatuses;
            return {
              facebookHandle: init.facebookHandle,
              instagramHandle: init.instagramHandle,
              linkedInHandle: init.linkedInHandle,
              twitterHandle: init.twitterHandle,
              yelpHandle: init.yelpHandle,
              youTubeHandle: status
            };
          });
          if (result$5 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$5,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateFacebookHandleField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.facebookHandle, state.submissionStatus, validators_facebookHandle, status => {
                let init = state.fieldsStatuses;
                return {
                  facebookHandle: status,
                  instagramHandle: init.instagramHandle,
                  linkedInHandle: init.linkedInHandle,
                  twitterHandle: init.twitterHandle,
                  yelpHandle: init.yelpHandle,
                  youTubeHandle: init.youTubeHandle
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateInstagramHandleField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.instagramHandle, state.submissionStatus, validators_instagramHandle, status => {
                let init = state.fieldsStatuses;
                return {
                  facebookHandle: init.facebookHandle,
                  instagramHandle: status,
                  linkedInHandle: init.linkedInHandle,
                  twitterHandle: init.twitterHandle,
                  yelpHandle: init.yelpHandle,
                  youTubeHandle: init.youTubeHandle
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateLinkedInHandleField" :
          let nextInput$2 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$2,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.linkedInHandle, state.submissionStatus, validators_linkedInHandle, status => {
                let init = state.fieldsStatuses;
                return {
                  facebookHandle: init.facebookHandle,
                  instagramHandle: init.instagramHandle,
                  linkedInHandle: status,
                  twitterHandle: init.twitterHandle,
                  yelpHandle: init.yelpHandle,
                  youTubeHandle: init.youTubeHandle
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateTwitterHandleField" :
          let nextInput$3 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$3,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.twitterHandle, state.submissionStatus, validators_twitterHandle, status => {
                let init = state.fieldsStatuses;
                return {
                  facebookHandle: init.facebookHandle,
                  instagramHandle: init.instagramHandle,
                  linkedInHandle: init.linkedInHandle,
                  twitterHandle: status,
                  yelpHandle: init.yelpHandle,
                  youTubeHandle: init.youTubeHandle
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateYelpHandleField" :
          let nextInput$4 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$4,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$4, state.fieldsStatuses.yelpHandle, state.submissionStatus, validators_yelpHandle, status => {
                let init = state.fieldsStatuses;
                return {
                  facebookHandle: init.facebookHandle,
                  instagramHandle: init.instagramHandle,
                  linkedInHandle: init.linkedInHandle,
                  twitterHandle: init.twitterHandle,
                  yelpHandle: status,
                  youTubeHandle: init.youTubeHandle
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateYouTubeHandleField" :
          let nextInput$5 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$5,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$5, state.fieldsStatuses.youTubeHandle, state.submissionStatus, validators_youTubeHandle, status => {
                let init = state.fieldsStatuses;
                return {
                  facebookHandle: init.facebookHandle,
                  instagramHandle: init.instagramHandle,
                  linkedInHandle: init.linkedInHandle,
                  twitterHandle: init.twitterHandle,
                  yelpHandle: init.yelpHandle,
                  youTubeHandle: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: initialFieldsStatuses(input),
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: initialFieldsStatuses(state.input),
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: map(error$2)
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateFacebookHandle: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateFacebookHandleField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateInstagramHandle: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateInstagramHandleField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateLinkedInHandle: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateLinkedInHandleField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateTwitterHandle: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateTwitterHandleField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateYelpHandle: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateYelpHandleField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateYouTubeHandle: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateYouTubeHandleField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurFacebookHandle: () => dispatch("BlurFacebookHandleField"),
    blurInstagramHandle: () => dispatch("BlurInstagramHandleField"),
    blurLinkedInHandle: () => dispatch("BlurLinkedInHandleField"),
    blurTwitterHandle: () => dispatch("BlurTwitterHandleField"),
    blurYelpHandle: () => dispatch("BlurYelpHandleField"),
    blurYouTubeHandle: () => dispatch("BlurYouTubeHandleField"),
    facebookHandleResult: Formality.exposeFieldResult(state.fieldsStatuses.facebookHandle),
    instagramHandleResult: Formality.exposeFieldResult(state.fieldsStatuses.instagramHandle),
    linkedInHandleResult: Formality.exposeFieldResult(state.fieldsStatuses.linkedInHandle),
    twitterHandleResult: Formality.exposeFieldResult(state.fieldsStatuses.twitterHandle),
    yelpHandleResult: Formality.exposeFieldResult(state.fieldsStatuses.yelpHandle),
    youTubeHandleResult: Formality.exposeFieldResult(state.fieldsStatuses.youTubeHandle),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.facebookHandle;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.instagramHandle;
      if (typeof tmp$1 === "object") {
        return true;
      }
      let tmp$2 = match.linkedInHandle;
      if (typeof tmp$2 === "object") {
        return true;
      }
      let tmp$3 = match.twitterHandle;
      if (typeof tmp$3 === "object") {
        return true;
      }
      let tmp$4 = match.yelpHandle;
      if (typeof tmp$4 === "object") {
        return true;
      }
      let tmp$5 = match.youTubeHandle;
      return typeof tmp$5 === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let FormConfig = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

let convertVariables = ProfilePageSocialMediaForm_UpdateAgentSocialMediaHandlesMutation_graphql.Internal.convertVariables;

let convertResponse = ProfilePageSocialMediaForm_UpdateAgentSocialMediaHandlesMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = ProfilePageSocialMediaForm_UpdateAgentSocialMediaHandlesMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, ProfilePageSocialMediaForm_UpdateAgentSocialMediaHandlesMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, ProfilePageSocialMediaForm_UpdateAgentSocialMediaHandlesMutation_graphql.node, convertResponse, convertWrapRawResponse);

let UpdateAgentSocialMediaHandlesMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

let convertFragment = ProfilePageSocialMediaForm_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ProfilePageSocialMediaForm_agent_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ProfilePageSocialMediaForm_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ProfilePageSocialMediaForm_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ProfilePageSocialMediaForm_agent_graphql.node, convertFragment, fRef);
}

let AgentFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ProfilePageSocialMediaForm(props) {
  let agent = RescriptRelay_Fragment.useFragment(ProfilePageSocialMediaForm_agent_graphql.node, convertFragment, props.agent);
  let match = use();
  let updateSocialMedia = match[0];
  let form = useForm({
    facebookHandle: agent.socialMedia.facebookHandle,
    instagramHandle: agent.socialMedia.instagramHandle,
    linkedInHandle: agent.socialMedia.linkedInHandle,
    twitterHandle: agent.socialMedia.twitterHandle,
    yelpHandle: agent.socialMedia.yelpHandle,
    youTubeHandle: agent.socialMedia.youTubeHandle
  }, (param, param$1) => {
    let notifyOnFailure = param$1.notifyOnFailure;
    let notifyOnSuccess = param$1.notifyOnSuccess;
    updateSocialMedia({
      input: {
        facebookHandle: param.facebookHandle,
        instagramHandle: param.instagramHandle,
        linkedInHandle: param.linkedInHandle,
        twitterHandle: param.twitterHandle,
        yelpHandle: param.yelpHandle,
        youTubeHandle: param.youTubeHandle
      }
    }, undefined, undefined, undefined, (param, param$1) => {
      let updateAgentSocialMediaHandles = param.updateAgentSocialMediaHandles;
      if (updateAgentSocialMediaHandles !== undefined && updateAgentSocialMediaHandles.__typename === "Agent") {
        return notifyOnSuccess(undefined);
      } else {
        return notifyOnFailure("Error updating data. Please refresh and try again...");
      }
    }, undefined, undefined);
  });
  let match$1 = form.facebookHandleResult;
  let tmp;
  tmp = match$1 !== undefined && match$1.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$1._0
    }) : undefined;
  let match$2 = form.twitterHandleResult;
  let tmp$1;
  tmp$1 = match$2 !== undefined && match$2.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$2._0
    }) : undefined;
  let match$3 = form.instagramHandleResult;
  let tmp$2;
  tmp$2 = match$3 !== undefined && match$3.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$3._0
    }) : undefined;
  let match$4 = form.yelpHandleResult;
  let tmp$3;
  tmp$3 = match$4 !== undefined && match$4.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$4._0
    }) : undefined;
  let match$5 = form.linkedInHandleResult;
  let tmp$4;
  tmp$4 = match$5 !== undefined && match$5.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$5._0
    }) : undefined;
  let match$6 = form.youTubeHandleResult;
  let tmp$5;
  tmp$5 = match$6 !== undefined && match$6.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$6._0
    }) : undefined;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(SettingsPageHeader.SectionHeading.make, {
            title: "Social accounts"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Form__Components.FormStatusMessageV2.make, {
              status: form.status,
              submissionErrorToString: v => v,
              onSuccessMessage: "Account updated",
              resetForm: form.reset,
              dismissSubmissionResult: form.dismissSubmissionResult
            }),
            className: "empty:hidden"
          })
        ],
        className: "mb-6 flex flex-col gap-4"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("p", {
          children: "Add links to your social media accounts. They'll appear on your TAN member profile."
        }),
        className: "mb-8"
      }),
      JsxRuntime.jsxs(Form.Group.make, {
        label: "Facebook",
        children: [
          JsxRuntime.jsx(Form__TextInput.make, {
            type: "text",
            onChange: event => form.updateFacebookHandle((v, value) => ({
              facebookHandle: Form__Helpers.noneIfEmpty(value),
              instagramHandle: v.instagramHandle,
              linkedInHandle: v.linkedInHandle,
              twitterHandle: v.twitterHandle,
              yelpHandle: v.yelpHandle,
              youTubeHandle: v.youTubeHandle
            }), event.target.value),
            onBlur: param => form.blurFacebookHandle(),
            disabled: form.submitting,
            status: Stdlib_Option.map(form.facebookHandleResult, x => {
              if (x.TAG === "Ok") {
                return "ok";
              } else {
                return "error";
              }
            }),
            value: Stdlib_Option.getOr(form.input.facebookHandle, "")
          }),
          JsxRuntime.jsx(Form__Components.FieldError.make, {
            valid: tmp
          })
        ]
      }),
      JsxRuntime.jsxs(Form.Group.make, {
        label: "Twitter",
        children: [
          JsxRuntime.jsx(Form__TextInput.make, {
            type: "text",
            onChange: event => form.updateTwitterHandle((v, value) => ({
              facebookHandle: v.facebookHandle,
              instagramHandle: v.instagramHandle,
              linkedInHandle: v.linkedInHandle,
              twitterHandle: Form__Helpers.noneIfEmpty(value),
              yelpHandle: v.yelpHandle,
              youTubeHandle: v.youTubeHandle
            }), event.target.value),
            onBlur: param => form.blurTwitterHandle(),
            disabled: form.submitting,
            status: Stdlib_Option.map(form.twitterHandleResult, x => {
              if (x.TAG === "Ok") {
                return "ok";
              } else {
                return "error";
              }
            }),
            value: Stdlib_Option.getOr(form.input.twitterHandle, "")
          }),
          JsxRuntime.jsx(Form__Components.FieldError.make, {
            valid: tmp$1
          })
        ]
      }),
      JsxRuntime.jsxs(Form.Group.make, {
        label: "Instagram",
        children: [
          JsxRuntime.jsx(Form__TextInput.make, {
            type: "text",
            onChange: event => form.updateInstagramHandle((v, value) => ({
              facebookHandle: v.facebookHandle,
              instagramHandle: Form__Helpers.noneIfEmpty(value),
              linkedInHandle: v.linkedInHandle,
              twitterHandle: v.twitterHandle,
              yelpHandle: v.yelpHandle,
              youTubeHandle: v.youTubeHandle
            }), event.target.value),
            onBlur: param => form.blurInstagramHandle(),
            disabled: form.submitting,
            status: Stdlib_Option.map(form.instagramHandleResult, x => {
              if (x.TAG === "Ok") {
                return "ok";
              } else {
                return "error";
              }
            }),
            value: Stdlib_Option.getOr(form.input.instagramHandle, "")
          }),
          JsxRuntime.jsx(Form__Components.FieldError.make, {
            valid: tmp$2
          })
        ]
      }),
      JsxRuntime.jsxs(Form.Group.make, {
        label: "Yelp",
        children: [
          JsxRuntime.jsx(Form__TextInput.make, {
            type: "text",
            onChange: event => form.updateYelpHandle((v, value) => ({
              facebookHandle: v.facebookHandle,
              instagramHandle: v.instagramHandle,
              linkedInHandle: v.linkedInHandle,
              twitterHandle: v.twitterHandle,
              yelpHandle: Form__Helpers.noneIfEmpty(value),
              youTubeHandle: v.youTubeHandle
            }), event.target.value),
            onBlur: param => form.blurYelpHandle(),
            disabled: form.submitting,
            status: Stdlib_Option.map(form.yelpHandleResult, x => {
              if (x.TAG === "Ok") {
                return "ok";
              } else {
                return "error";
              }
            }),
            value: Stdlib_Option.getOr(form.input.yelpHandle, "")
          }),
          JsxRuntime.jsx(Form__Components.FieldError.make, {
            valid: tmp$3
          })
        ]
      }),
      JsxRuntime.jsxs(Form.Group.make, {
        label: "LinkedIn",
        children: [
          JsxRuntime.jsx(Form__TextInput.make, {
            type: "text",
            onChange: event => form.updateLinkedInHandle((v, value) => ({
              facebookHandle: v.facebookHandle,
              instagramHandle: v.instagramHandle,
              linkedInHandle: Form__Helpers.noneIfEmpty(value),
              twitterHandle: v.twitterHandle,
              yelpHandle: v.yelpHandle,
              youTubeHandle: v.youTubeHandle
            }), event.target.value),
            onBlur: param => form.blurLinkedInHandle(),
            disabled: form.submitting,
            status: Stdlib_Option.map(form.linkedInHandleResult, x => {
              if (x.TAG === "Ok") {
                return "ok";
              } else {
                return "error";
              }
            }),
            value: Stdlib_Option.getOr(form.input.linkedInHandle, "")
          }),
          JsxRuntime.jsx(Form__Components.FieldError.make, {
            valid: tmp$4
          })
        ]
      }),
      JsxRuntime.jsxs(Form.Group.make, {
        label: "Youtube",
        children: [
          JsxRuntime.jsx(Form__TextInput.make, {
            type: "text",
            onChange: event => form.updateYouTubeHandle((v, value) => ({
              facebookHandle: v.facebookHandle,
              instagramHandle: v.instagramHandle,
              linkedInHandle: v.linkedInHandle,
              twitterHandle: v.twitterHandle,
              yelpHandle: v.yelpHandle,
              youTubeHandle: Form__Helpers.noneIfEmpty(value)
            }), event.target.value),
            onBlur: param => form.blurYouTubeHandle(),
            disabled: form.submitting,
            status: Stdlib_Option.map(form.youTubeHandleResult, x => {
              if (x.TAG === "Ok") {
                return "ok";
              } else {
                return "error";
              }
            }),
            value: Stdlib_Option.getOr(form.input.youTubeHandle, "")
          }),
          JsxRuntime.jsx(Form__Components.FieldError.make, {
            valid: tmp$5
          })
        ]
      }),
      JsxRuntime.jsx(Form.Group.make, {
        children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
          onClick: extra => Form__Helpers.preventDefault(form.submit, extra),
          disabled: !form.valid() || form.submitting,
          children: "Save"
        })
      })
    ],
    className: "flex flex-col"
  });
}

let PrimaryButton;

let make = ProfilePageSocialMediaForm;

exports.FormConfig = FormConfig;
exports.UpdateAgentSocialMediaHandlesMutation = UpdateAgentSocialMediaHandlesMutation;
exports.AgentFragment = AgentFragment;
exports.PrimaryButton = PrimaryButton;
exports.make = make;
/* commitMutation Not a pure module */
